// @flow

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import StartSaleOrderReturnRequestPage from "./pages/StartSaleOrderReturnRequestPage";
import ManageSaleOrderReturnRequestPage from "./pages/ManageSaleOrderReturnRequestPage";
import { AppProvider } from "./context/AppContext";
import { LanguageProvider } from "./i18n";

const theme = createTheme();

function App(): React$Node {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <LanguageProvider>
                <AppProvider>
                    <Router>
                        <Routes>
                            <Route path="/" element={<StartSaleOrderReturnRequestPage />} />
                            <Route path="/manage" element={<ManageSaleOrderReturnRequestPage />} />
                        </Routes>
                    </Router>
                </AppProvider>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
